import { getUniqueId } from 'utils/common'

export const generateNewBlock = blockType => ({ type: blockType, id: getUniqueId() })
